import React from 'react';
import { Box, styled, Typography } from '@mui/material';
import AppLogo from '../assets/personImage.jpg';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { StyledGreenButton, StyledRowBox } from '../theme/StyledElements';

const StyledInformation = styled(Box)(() => ({
    width: '50vw',
    borderTop: '3px solid #134C03',
    borderLeft: '3px solid #134C03',
    height: '100%',
    flexGrow: 1
}));

const StyledInformationHeader = styled(Box)(() => ({
    backgroundColor: '#FFAF50',
    padding: '40px'
}));

const StyledInformationPlainHeader = styled(Box)(() => ({
    padding: '40px',
    marginBottom: '60px'
}));

const StyledInformationHeaderText = styled(Typography)(() => ({
    color: '#134C03',
    marginBottom: '20px'
}));

const StyledInformationHeaderBody = styled(Typography)(() => ({
    color: '#134C03',
    fontWeight: 500
}));

const StyledInformationButton = styled(StyledGreenButton)(() => ({
    width: '150px'
}));

const StyledInformationImage = styled('img')(() => ({
    height: '174px',
    objectFit: 'contain',
    width: '50%'
}));

export function GeneralInformation(): React.ReactElement {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <StyledInformation>
            <StyledInformationHeader>
                <StyledInformationHeaderText variant="h3">
                    {t('informationTitle')}
                </StyledInformationHeaderText>
                <StyledRowBox>
                    <Box sx={{ marginRight: '30px', width: '50%' }}>
                        <StyledInformationHeaderBody variant="h5" sx={{ marginBottom: '10px' }}>
                            {t('informationBody1')}
                        </StyledInformationHeaderBody>
                        <StyledInformationHeaderBody variant="h5">
                            {t('informationBody2')}
                        </StyledInformationHeaderBody>
                    </Box>
                    <Box sx={{ marginRight: '60px', width: '50%' }}>
                        <StyledInformationHeaderBody variant="h5" sx={{ marginBottom: '10px' }}>
                            {t('informationBody3')}
                        </StyledInformationHeaderBody>
                        <StyledInformationHeaderBody variant="h5">
                            {t('informationBody4')}
                        </StyledInformationHeaderBody>
                    </Box>
                </StyledRowBox>
            </StyledInformationHeader>
            <StyledInformationPlainHeader>
                <StyledInformationHeaderText variant="h3">
                    {t('requestForDemo')}
                </StyledInformationHeaderText>
                <StyledRowBox>
                    <Box sx={{ marginRight: '20px', width: '50%' }}>
                        <StyledInformationHeaderBody variant="h5" sx={{ marginBottom: '10px' }}>
                            {t('requestForDemoBody1')}
                        </StyledInformationHeaderBody>
                        <StyledInformationHeaderBody variant="h5" sx={{ marginBottom: '20px' }}>
                            {t('requestForDemoBody2')}
                        </StyledInformationHeaderBody>
                        <StyledInformationButton
                            onClick={(): void => {
                                navigate('/register');
                            }}>
                            <Typography variant="caption" color="#FFFFFF">
                                {t('makeAnAppointment')}
                            </Typography>
                        </StyledInformationButton>
                    </Box>
                    <StyledInformationImage src={AppLogo} />
                </StyledRowBox>
            </StyledInformationPlainHeader>
        </StyledInformation>
    );
}
